<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { FileCheck, FileQuestion } from 'lucide-vue-next'
  import FullScreenModal from '@/components/FullScreenModal.vue'
  import DataViewer from '@/components/DataViewer.vue'
  import { AdvancedAnalysisWizardModel } from '../../models/AdvancedAnalysisWizardModel'

  export interface IAdvancedAnalysisStepStatusProps {
    wizardModel: AdvancedAnalysisWizardModel
  }

  const props = defineProps<IAdvancedAnalysisStepStatusProps>()

  const dataViewerModalOpen = ref<boolean>(false)

  const viewFileData = async () => {
    if (props.wizardModel.sharedModel?.inputFile?.id != null) {
      dataViewerModalOpen.value = true
    }
  }

  const closeDataViewerModal = () => {
    dataViewerModalOpen.value = false
  }

  const hasInputFile = computed(() => props.wizardModel.sharedModel?.inputFile != null)
</script>

<template>
  <a-tooltip>
    <template #title>
      {{ 'Select file to preview' }}
    </template>

    <div @click="viewFileData" class="flex" :class="{ 'cursor-pointer': hasInputFile }">
      <component
        :is="hasInputFile ? FileCheck : FileQuestion"
        class="size-6"
        :style="{
          color: hasInputFile ? 'var(--primary, #5aa745)' : 'var(--foreground-80, #9CA3AF)'
        }"
        aria-hidden="true"
      />

      <span class="ml-2 self-center truncate">
        <b>Input dataset:</b>
        <span class="ml-1">
          {{ hasInputFile ? props.wizardModel.sharedModel?.inputFile?.name : 'No input data' }}
        </span>
      </span>
    </div>
  </a-tooltip>
  <!-- Data Viewer Modal -->
  <FullScreenModal
    :open="dataViewerModalOpen"
    title="Data Viewer"
    :description="props.wizardModel.sharedModel?.inputFile?.name"
    @close="closeDataViewerModal"
  >
    <DataViewer :fileId="props.wizardModel.sharedModel?.inputFile?.id || ''" />
  </FullScreenModal>
</template>
